import { getCameraPoseClickedMessage } from 'features/kestrelViewer/messages/cameraPoseClicked'
import { getConfirmIdMessage } from 'features/kestrelViewer/messages/confirmId'
import { getControlMessage } from 'features/kestrelViewer/messages/control'
import { getNewAnnotationMessage } from 'features/kestrelViewer/messages/newAnnotation'
import { getNewCameraViewMessage } from 'features/kestrelViewer/messages/newCameraView'
import { getNewMeasurementMessage } from 'features/kestrelViewer/messages/newMeasurement'
import { getNewPolygonMessage } from 'features/kestrelViewer/messages/newPolygon'
import { getSetMeasurementScaleMessage } from 'features/kestrelViewer/messages/setMeasurementScale'
import { getSettingsUpdatedMessage } from 'features/kestrelViewer/messages/settings'
import { getSliceOnOrbitMessage } from 'features/kestrelViewer/messages/sliceOnOrbit'
import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'

import { getNavigationModeUpdatedMessage } from './navigationModeUpdated'
import { getNewPlaneIntersectionMessage } from './newPlaneIntersection'
import { getNewSurfaceAreaMessage } from './newSurfaceArea'
import { getOrbitPlacedMessage } from './orbitPlaced'

export type KVMessageDef = {
  type: string
  requiredData: string[]

  callback: (
    json: Record<string, unknown>,
    kv: KestrelViewerMessageCallbackAPI
  ) => void
}

export function getAllMessages(): KVMessageDef[] {
  return [
    getConfirmIdMessage(),
    getControlMessage(),
    getNewAnnotationMessage(),
    getNewMeasurementMessage(),
    getNewCameraViewMessage(),
    getNewPolygonMessage(),
    getSetMeasurementScaleMessage(),
    getSliceOnOrbitMessage(),
    getSettingsUpdatedMessage(),
    getNewPlaneIntersectionMessage(),
    getNewSurfaceAreaMessage(),
    getCameraPoseClickedMessage(),
    getOrbitPlacedMessage(),
    getNavigationModeUpdatedMessage(),
  ]
}
